import { render, staticRenderFns } from "./rec_doc_ret_guide.vue?vue&type=template&id=75df53c8&scoped=true&"
import script from "./rec_doc_ret_guide.vue?vue&type=script&lang=js&"
export * from "./rec_doc_ret_guide.vue?vue&type=script&lang=js&"
import style0 from "./rec_doc_ret_guide.vue?vue&type=style&index=0&id=75df53c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df53c8",
  null
  
)

export default component.exports